module.exports = __webpack_public_path__ + "static/media/personEmpty.cf89e8e6.png";